/**
 * Shared fitment-setup logic for the YMM finder, the collection vehicle panel and
 * the product fit badge. One file on purpose: the tire upsell was three drifting
 * copies of the same script and a fix to one left the bug live in the others.
 *
 * Data it reads (built by refresh-ymm.py):
 *   bundle.facets[D]        = { w: ['7"','9"','9.0"',...], o: ['-12','0','18','+18',...] }
 *                             the EXACT spellings this diameter's collection facets use
 *   make.r[trim][D][W]      = [[minOffset, maxOffset, code], ...]   incl. clean rows (code '')
 *
 * Codes come from AutoSync PlusSize notes. Which ones block a fit depends on the
 * shopper's setup - agreed mapping:
 *   Stock    blocks  C L M B X O      (C = clearance, needs a leveling kit)
 *   Leveled  blocks    L M B X O      (L/M = needs a lift kit / suspension mod)
 *   Lifted   blocks        B X O      (body mod, extreme, OE-rims-only: nothing satisfies)
 *   K N S F T never block - they are informational (brake, lug, tire suitability, alignment).
 * AutoSync fitment rows do NOT vary by lift height, so a setup is one of three states;
 * the inch value is carried only for the visualizer render.
 */
(function () {
  if (window.YMM_SETUP) return;

  var BLOCK = { stock: 'CLMBXO', leveled: 'LMBXO', lifted: 'BXO' };
  var INFO = 'KNSFTW';
  var WORDS = {
    L: 'a lift kit', M: 'a suspension modification', C: 'clearance work',
    B: 'body modification', X: 'supplier confirmation (extreme fitment)',
    O: 'OE rims only — no aftermarket listed',
    K: 'a brake clearance check', N: 'a lug hardware check', S: 'a tire suitability check',
    W: 'winter wheel only',
    F: 'a lug hardware check', T: 'an alignment check'
  };

  function saved() { try { return JSON.parse(localStorage.getItem('ymm') || '{}') || {}; } catch (e) { return {}; } }
  function setup() { var s = saved().setup; return BLOCK[s] ? s : 'stock'; }
  function setSetup(s, inches) {
    var v = saved(); v.setup = BLOCK[s] ? s : 'stock';
    if (inches !== undefined) v.lift = inches;
    try { localStorage.setItem('ymm', JSON.stringify(v)); } catch (e) {}
  }

  function blockers(code, s) {
    var b = BLOCK[s] || BLOCK.stock, out = '';
    for (var i = 0; i < code.length; i++) if (b.indexOf(code[i]) !== -1) out += code[i];
    return out;
  }
  function infos(code) { var out = ''; for (var i = 0; i < code.length; i++) if (INFO.indexOf(code[i]) !== -1) out += code[i]; return out; }
  function words(letters) {
    var seen = {}, out = [];
    for (var i = 0; i < letters.length; i++) { var w = WORDS[letters[i]]; if (w && !seen[w]) { seen[w] = 1; out.push(w); } }
    return out.join(' + ');
  }

  function trimRows(detail, mo, sb) {
    var r = detail && detail.r; if (!r) return null;
    var t = r[mo + '|' + (sb || '')];
    if (!t) { for (var k in r) { if (k.indexOf(mo + '|') === 0) { t = r[k]; break; } } }
    return t || null;
  }

  // Every (width, offset range) at this diameter that FITS at the setup, plus the
  // blockers that would have applied - so callers can say "fits" or "needs X".
  function fitting(detail, mo, sb, dia, s) {
    var t = trimRows(detail, mo, sb), byW = (t && t[String(dia)]) || null;
    if (!byW) return null;
    var widths = {}, offsets = {}, anyRows = false;
    for (var w in byW) {
      var rows = byW[w];
      for (var i = 0; i < rows.length; i++) {
        anyRows = true;
        if (blockers(rows[i][2], s)) continue;
        widths[parseFloat(w)] = 1;
        for (var o = Math.ceil(rows[i][0]); o <= Math.floor(rows[i][1]); o++) offsets[o] = 1;
      }
    }
    return anyRows ? { widths: widths, offsets: offsets } : null;
  }

  var W_RE = /^(\d+(?:\.\d+)?)"$/, O_RE = /^[-+]?(\d+(?:\.\d+)?)$/;

  // Collection URL narrowed to what fits: bolt pattern + every width spelling and
  // offset spelling this collection actually has that falls inside a fitting row.
  // Unknown facet spellings (CUSTOM, STAGGERED, xx) are simply never emitted.
  function wheelUrl(dia, bolt, fit, facets) {
    var url = '/collections/' + dia + '-wheels?filter.p.m.custom.bolt_pattern_2=' + encodeURIComponent(bolt);
    if (!fit || !facets) return url;
    var W = 'filter.p.m.custom.wheel_width', O = 'filter.v.option.offset', n = 0;
    (facets.w || []).forEach(function (sp) {
      var m = W_RE.exec(sp); if (m && fit.widths[parseFloat(m[1])]) { url += '&' + encodeURIComponent(W) + '=' + encodeURIComponent(sp); n++; }
    });
    (facets.o || []).forEach(function (sp) {
      var m = O_RE.exec(sp); if (m && fit.offsets[Math.round(parseFloat(sp))]) { url += '&' + encodeURIComponent(O) + '=' + encodeURIComponent(sp); n++; }
    });
    return n ? url : url;   // no matching spellings -> plain bolt-pattern URL (never a dead end)
  }

  // For one wheel (dia, width, offset): fits / needs / info at this setup.
  function judge(detail, mo, sb, dia, width, offset, s) {
    var t = trimRows(detail, mo, sb), rows = t && t[String(dia)] && t[String(dia)][String(parseFloat(width))];
    if (!rows) {                      // try alternate width spellings ("9" vs "9.0")
      var byW = t && t[String(dia)]; if (byW) for (var w in byW) if (parseFloat(w) === parseFloat(width)) { rows = byW[w]; break; }
    }
    if (!rows || !rows.length) return null;
    var off = parseFloat(offset), cover = [], clean = 0, need = '', info = '';
    for (var i = 0; i < rows.length; i++) {
      var r = rows[i];
      if (!isNaN(off) && (off < r[0] || off > r[1])) continue;
      cover.push(r);
      var b = blockers(r[2], s);
      if (!b) clean++; else need += b;
      info += infos(r[2]);
    }
    if (!cover.length) return null;
    return { fits: clean > 0, definite: clean === 0, need: words(need), info: words(info) };
  }

  var LABEL = { stock: 'Factory height', leveled: 'Leveled', lifted: 'Lifted' };
  window.YMM_SETUP = { BLOCK: BLOCK, setup: setup, setSetup: setSetup, label: function (s) { return LABEL[s] || LABEL.stock; },
                       blockers: blockers, infos: infos, words: words, trimRows: trimRows, fitting: fitting, wheelUrl: wheelUrl, judge: judge };
})();
